export const color = {
    primaryColor: '#242424',
    secondaryColor: "#101010",
    focusedColor: "#0B0B0B",
    lightBackground: "#F6F6F6",
    errorColor: "#EE1D52",
    textColor: "#666666",
    titleColor: '#333333',
    white: "#fffff",
};